import { AVATARS, STYLE_OPTIONS, VOICES } from "@easyshot/shared";
import { AvatarUploads } from "@/components/avatar-uploads";
import { AvatarVideo } from "@/components/avatar-video";
import { Badge, Card, LinkButton } from "@/components/ui";

export const metadata = { title: "Avatars — EasyShot Studio" };

export default function AvatarsPage() {
  return (
    <div className="mx-auto max-w-5xl px-5 py-8 sm:py-10">
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Avatars</h1>
          <p className="mt-2 text-sm text-muted">
            {AVATARS.length} studio presenters · new avatars added monthly.
            Custom avatar cloning is coming soon.
          </p>
        </div>
        <LinkButton href="/studio">Use in a new video</LinkButton>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {AVATARS.map((a) => (
          <Card key={a.id} className="overflow-hidden p-0">
            <AvatarVideo avatarId={a.id} className="h-44 w-full" />
            <div className="space-y-2.5 p-4">
              <div className="flex items-center justify-between">
                <span className="text-[15px] font-semibold">{a.name}</span>
                {a.premium ? (
                  <Badge tone="accent">Premium</Badge>
                ) : (
                  <Badge>Included</Badge>
                )}
              </div>
              <div className="text-[12px] text-muted">
                {a.gender === "female" ? "Female" : "Male"} · {a.ageRange} ·{" "}
                {a.locale}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {a.styles.map((s) => (
                  <Badge key={s}>
                    {STYLE_OPTIONS.find((o) => o.id === s)?.label ?? s}
                  </Badge>
                ))}
              </div>
            </div>
          </Card>
        ))}
      </div>

      <AvatarUploads />

      <h2 className="mt-12 mb-3 text-sm font-medium text-muted">Voices</h2>
      <Card className="divide-y divide-[var(--border)] p-0">
        {VOICES.map((v) => (
          <div
            key={v.id}
            className="flex items-center justify-between px-5 py-3.5 text-sm"
          >
            <span>{v.name}</span>
            <span className="text-[12px] text-muted">
              {v.locale} · {v.speed}x speed
            </span>
          </div>
        ))}
      </Card>
    </div>
  );
}
